export { default as ImageProduct } from './image-product'
